import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Cancel and Save button row fixed at the bottom of the create-task panel. */
export function CreateTaskFooter(_ref) {
  var isSaveDisabled = _ref.isSaveDisabled,
    isSaving = _ref.isSaving,
    onCancel = _ref.onCancel,
    onSave = _ref.onSave;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 px-4 py-4 border-t border-sds-base-default flex-shrink-0"
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "create-task-cancel",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.CREATE_TASK_CANCEL);
      onCancel();
    },
    disabled: isSaving,
    className: "flex-1 h-8 rounded-sds-100 text-style-body-strong text-sds-base-secondary bg-sds-base-secondary border border-sds-base-default hover:bg-sds-base-default transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
  }, t("button.cancel")), /*#__PURE__*/React.createElement("button", {
    "data-testid": "create-task-save",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.CREATE_TASK_SAVE);
      onSave();
    },
    disabled: isSaveDisabled,
    className: "flex-1 h-8 rounded-sds-100 text-style-body-strong text-sds-brand-on-brand bg-sds-brand-default hover:bg-sds-brand-secondary transition-colors disabled:bg-sds-disabled-default disabled:text-sds-disabled-secondary disabled:cursor-not-allowed"
  }, isSaving ? t("message.saving") : t("button.save")));
}